<section class="content text-center noresult mt-5">
  <div class="container">
    <div class="row h-100">
      <div class="col-md-12">
        <i-title text="Vous n'avez pas le droit de voir la plateforme!" level="1"></i-title>
        <div class="text-center d-flex align-items-center">
          <img src="./assets/img/security.svg" />
        </div>
      </div>
    </div>
  </div>
</section>
